import { useState } from "react"
import { Link } from "react-router-dom"
import { authService } from "../../services/authService"

type ConfirmAccountDeletionProps = {
  token: string
}

export default function ConfirmAccountDeletion({ token }: ConfirmAccountDeletionProps) {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle")
  const [message, setMessage] = useState("")

  const handleConfirm = async () => {
    setStatus("loading")
    try {
      const result = await authService.confirmAccountDeletion(token)
      setMessage(result.message)
      setStatus("success")
    } catch {
      setStatus("error")
      setMessage(
        "This confirmation link is invalid or has expired. You can submit a new deletion request from the account deletion page.",
      )
    }
  }

  if (status === "success") {
    return (
      <div className="mt-8 space-y-4 text-center">
        <p className="text-sm text-gray-700">{message}</p>
        <Link to="/" className="text-primary hover:underline font-medium">
          Return to home
        </Link>
      </div>
    )
  }

  if (status === "error") {
    return (
      <div className="mt-8 space-y-4 text-center">
        <p className="text-sm text-red-700">{message}</p>
        <Link to="/deleteAccount" className="text-primary hover:underline font-medium">
          Request account deletion again
        </Link>
      </div>
    )
  }

  return (
    <div className="mt-8 space-y-6">
      <p className="text-center text-sm text-gray-600">
        This action cannot be undone. Your personal account data will be deleted after you confirm below.
        Walk and company operational records are retained as business records for the employer.
      </p>
      <button
        type="button"
        disabled={status === "loading"}
        onClick={handleConfirm}
        className="w-full py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-secondary hover:bg-secondary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary disabled:opacity-60"
      >
        {status === "loading" ? "Deleting account…" : "Confirm account deletion"}
      </button>
      <div className="text-center">
        <Link to="/" className="text-sm text-gray-600 hover:text-primary">
          Cancel and return to home
        </Link>
      </div>
    </div>
  )
}
